module.exports = __webpack_public_path__ + "img/directory_banner.4d5ff5a.svg";